import { DispatchersSectorsRepository } from '../repositories/dispatchers_sectors.repository'

import {
    DispatcherSectorPayloadT,
    DispatchersSectorsGetListResponseT,
} from '../types/dispatchers_sector.types'
import { SectorsGetListResponseT } from '../types/sectors.types'

const dispatchersSectorsRepository = new DispatchersSectorsRepository()

export class DispatchersSectorsService {
    async attachUser(user_id: number, sector_ids: number[]): Promise<void> {
        const response = await dispatchersSectorsRepository.attachUser(user_id, sector_ids)
        return response.data
    }

    async getList(): Promise<DispatchersSectorsGetListResponseT> {
        const response = await dispatchersSectorsRepository.getList()
        return response.data
    }

    async getSectors(dispatcher_sector_id: number): Promise<SectorsGetListResponseT> {
        const response = await dispatchersSectorsRepository.getSectors(dispatcher_sector_id)
        return response.data
    }

    async updateSector(
        dispatcher_sector_id: number,
        payload: DispatcherSectorPayloadT
    ): Promise<void> {
        const response = await dispatchersSectorsRepository.updateSector(
            dispatcher_sector_id,
            payload
        )
        return response.data
    }

    async createSector(payload: DispatcherSectorPayloadT): Promise<void> {
        await dispatchersSectorsRepository.createSector(payload)
    }

    async deleteSector(dispatcher_sector_id: number): Promise<void> {
        await dispatchersSectorsRepository.deleteSector(dispatcher_sector_id)
    }
}
